import React, { useEffect, useRef, useState } from "react";
import styles from "assets/jss/material-dashboard-pro-react/views/formsStyle.js";
import { makeStyles } from "@material-ui/core";
import PropTypes from "prop-types";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Card from "components/Card/Card";
import CardHeader from "components/Card/CardHeader";
import CardIcon from "components/Card/CardIcon";
import MailOutline from "@material-ui/icons/MailOutline";
import CardBody from "components/Card/CardBody";
import Button from "components/CustomButtons/Button.js";
import { useParams, Redirect } from "react-router-dom";
import { yuuApi } from "functions/apis";
import CustomInput from "components/CustomInput/CustomInput";
import { formatCurrency } from "functions/Helper";
import { formatDateTime } from "functions/Helper";

const useStyles = makeStyles(styles);

const Retry = props => {
  const classes = useStyles();
  const viewYuuTransactionSignal = useRef(new AbortController());

  const [data, setData] = useState(null);
  const [disabled, setDisabled] = useState(false);
  const [redirect, setRedirect] = useState(false);

  const { id } = useParams();

  useEffect(() => {
    yuuApi
      .get(`/Transactions/${id}`, {
        signal: viewYuuTransactionSignal.current.signal
      })
      .then(resp => {
        setData(resp);
      })
      .catch(err => console.log(err));

    return () => viewYuuTransactionSignal.current.abort();
  }, []);

  const handleRetry = e => {
    e.preventDefault();
    setDisabled(true);

    yuuApi
      .post(`/Transactions/Retry/${id}`, null, {
        signal: viewYuuTransactionSignal.current.signal
      })
      .then(() => setRedirect(true))
      .finally(() => {
        setDisabled(false);
      });
  };

  return redirect ? (
    <Redirect to={"/admin/YuuTransaction/Failed"} />
  ) : (
    <GridContainer>
      <GridItem xs={12}>
        <Card>
          <CardHeader color="rose" icon>
            <CardIcon color="rose">
              <MailOutline />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>RETRY YUU TRANSACTION</h4>
          </CardHeader>
          <CardBody>
            <p>
              <i>*Are you sure you want to retry this Yuu Transaction?</i>
            </p>
            <form onSubmit={handleRetry}>
              <Button onClick={() => props.history.goBack()} value="Back">
                BACK
              </Button>
              <Button
                disabled={disabled}
                color="rose"
                type="submit"
                value="Submit"
              >
                RETRY
              </Button>
            </form>
            {data && (
              <GridContainer>
                <GridItem xs={12} md={6}>
                  <CustomInput
                    labelText="Tomo ID"
                    formControlProps={{
                      fullWidth: true
                    }}
                    disabled
                    inputProps={{
                      value: data.tomoId
                    }}
                  />
                </GridItem>
                <GridItem xs={12} md={6}>
                  <CustomInput
                    labelText="Reference No"
                    formControlProps={{
                      fullWidth: true
                    }}
                    disabled
                    inputProps={{
                      value: data.referenceNo
                    }}
                  />
                </GridItem>
                <GridItem xs={12} md={12}>
                  <CustomInput
                    labelText="Created At"
                    formControlProps={{
                      fullWidth: true
                    }}
                    disabled
                    inputProps={{
                      value: formatDateTime(data.createdAt)
                    }}
                  />
                </GridItem>
                <GridItem xs={12} md={12}>
                  <CustomInput
                    labelText="Description"
                    formControlProps={{
                      fullWidth: true
                    }}
                    disabled
                    inputProps={{
                      value: data.description
                    }}
                  />
                </GridItem>
                <GridItem xs={12} md={6}>
                  <CustomInput
                    labelText="PWP Amount"
                    formControlProps={{
                      fullWidth: true
                    }}
                    disabled
                    inputProps={{
                      value: formatCurrency("SGD", data.pwpAmount)
                    }}
                  />
                </GridItem>
                <GridItem xs={12} md={6}>
                  <CustomInput
                    labelText="Paid Amount"
                    formControlProps={{
                      fullWidth: true
                    }}
                    disabled
                    inputProps={{
                      value: formatCurrency("SGD", data.paidAmount)
                    }}
                  />
                </GridItem>
                {data.refundedAmount &&
                Number(data.refundedAmount) > 0 &&
                !Number.isNaN(data.refundedAmount) ? (
                  <GridItem xs={12} md={12}>
                    <CustomInput
                      labelText="Refund Amount"
                      formControlProps={{
                        fullWidth: true
                      }}
                      disabled
                      inputProps={{
                        value: formatCurrency("SGD", data.refundedAmount)
                      }}
                    />
                  </GridItem>
                ) : null}
                <GridItem xs={12} md={12}>
                  <CustomInput
                    labelText="Amount"
                    formControlProps={{
                      fullWidth: true
                    }}
                    disabled
                    inputProps={{
                      value: formatCurrency("SGD", data.amount)
                    }}
                  />
                </GridItem>
              </GridContainer>
            )}
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
};

export default Retry;

Retry.propTypes = {
  history: PropTypes.object
};
